var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-row",
        { attrs: { dense: true } },
        [
          _c(
            "v-col",
            { staticClass: "text-subtitle-2", attrs: { cols: "12" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("campaign_factory.test.consent_grants.title")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.grants, function (grant, grantIndex) {
        return _c(
          "v-row",
          {
            key: grantIndex,
            attrs: { dense: true, "data-cy": "consent-grant-row" },
          },
          [
            _c(
              "v-col",
              { attrs: { cols: "3" } },
              [
                _c("v-text-field", {
                  attrs: {
                    name: "consent_grant_advertiser_" + grantIndex,
                    label: _vm.$t(
                      "campaign_factory.test.consent_grants.advertiser_id"
                    ),
                    type: "number",
                    dense: true,
                  },
                  model: {
                    value: grant.advertiserId,
                    callback: function ($$v) {
                      _vm.$set(grant, "advertiserId", $$v)
                    },
                    expression: "grant.advertiserId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.channels, function (channel) {
              return _c(
                "v-col",
                { key: channel, attrs: { cols: "auto" } },
                [
                  _c("v-select", {
                    staticStyle: { "max-width": "130px" },
                    attrs: {
                      value: _vm.stateOf(grant, channel),
                      items: _vm.statusItems,
                      name: "consent_state_" + channel + "_" + grantIndex,
                      label: channel,
                      dense: true,
                      "hide-details": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.setState(grant, channel, $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  "none" !== _vm.stateOf(grant, channel)
                    ? _c("v-text-field", {
                        staticStyle: { "max-width": "130px" },
                        attrs: {
                          value: _vm.grantedAtOf(grant, channel),
                          name:
                            "consent_granted_at_" + channel + "_" + grantIndex,
                          label: _vm.$t(
                            "campaign_factory.test.consent_grants.granted_at"
                          ),
                          type: "date",
                          dense: true,
                          "hide-details": "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setGrantedAt(grant, channel, $event)
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  "withdrawn" === _vm.stateOf(grant, channel)
                    ? _c("v-text-field", {
                        staticStyle: { "max-width": "130px" },
                        attrs: {
                          value: _vm.withdrawnAtOf(grant, channel),
                          name:
                            "consent_withdrawn_at_" +
                            channel +
                            "_" +
                            grantIndex,
                          label: _vm.$t(
                            "campaign_factory.test.consent_grants.withdrawn_at"
                          ),
                          type: "date",
                          dense: true,
                          "hide-details": "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setWithdrawnAt(grant, channel, $event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "v-col",
              { attrs: { cols: "auto" } },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "mt-2",
                    attrs: { small: "", color: "red" },
                    on: {
                      click: function ($event) {
                        return _vm.removeGrant(grantIndex)
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { color: "white" } }, [
                      _vm._v("mdi-minus"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mb-5", attrs: { dense: true } },
        [
          _c(
            "v-col",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    color: "primary",
                    "data-cy": "btn-add-consent-grant",
                  },
                  on: { click: _vm.addGrant },
                },
                [
                  _c("v-icon", { attrs: { dark: "", left: "" } }, [
                    _vm._v("mdi-plus"),
                  ]),
                  _vm._v(
                    _vm._s(_vm.$t("campaign_factory.test.consent_grants.add"))
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }